import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientService } from '../patient/patient.service';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { MyReportsService } from '../../my-reports/my-reports.service';
import { Utility } from 'src/app/framework/utils/utility';

@Component({
  selector: 'app-additional-analysis-request',
  templateUrl: './additional-analysis-request.component.html',
  styleUrls: ['./additional-analysis-request.component.scss']
})
export class AdditionalAnalysisRequestComponent implements OnInit {

  

  isAdditionalAnalysisReqConsent = false;
  showThankYou: boolean = false;

  constructor(
    private readonly  pservice: PatientService,
    private readonly myReportsService: MyReportsService,
    private readonly snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<AdditionalAnalysisRequestComponent>,
    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.showThankYou = data?.showThankYou || false;
    console.log(
  "payload:",
  JSON.stringify(data));
  }

  ngOnInit(): void {
  }

  onBack(): void {
  this.dialogRef.close('back');
}


  onSubmit(): void {

  const patientId = localStorage.getItem('patientID');

  if (!patientId) {
    this.snackBarService.error('Patient ID not found');
    return;
  }

  this.pservice.getPatientDetails(patientId).subscribe({
    next: (patient) => {

      if (!patient) {
        this.snackBarService.error('Patient details are empty');
        return;
      }

      delete patient.createdDate;
      delete patient.updatedDate;

      const savePayload = {
        ...this.data.payload, 
        isAdditionalAnalysisReqConsent: this.isAdditionalAnalysisReqConsent
      };

      this.pservice.savePatientAnalysisRequest(savePayload).subscribe({
        next: () => {

          // Payload for `/user/notify-analysis-request` must match the expected backend shape.
          const selectedPackages = (this.data?.originalData?.selectedPackages ?? []).map(
            (pkg: any) => ({
              packageId: pkg.packageId,
              packageName: pkg.packageName,
              templateIds: pkg.templateIds ?? [],
              templateNames: pkg.templateNames ?? []
            })
          );

          const notificationPayload = {
            patientId: Number(this.data?.originalData?.patientId ?? patientId),
            selectedPackages,
            patient: {
              id: patient?.id,
              storegeneId: patient?.storegeneId,
              surName: patient?.surName,
              dob: patient?.dob ? Utility.transformDateToString(patient.dob) : patient?.dob,
              lastAction: patient?.lastAction
                ? Utility.transformDateToString(patient.lastAction)
                : patient?.lastAction,
              genomeData: {
                barcode: patient?.genomeData?.barcode ?? patient?.genomedata?.barcode
              },
              email: patient?.email,
              geneticSex: patient?.geneticSex,
              firstName: patient?.firstName
            }
          };

          this.pservice.sendAnalysisRequestNotification(notificationPayload).subscribe({
            next: () => {
              this.showThankYou = true;
            },
            error: (error) => {
              this.snackBarService.error(
                error?.error?.applicationMessage || 'Failed to send notification'
              );
            }
          });

        },
        error: (error) => {
          this.snackBarService.error(
            error?.error?.applicationMessage || 'Failed to save analysis request'
          );
        }
      });

    },
    error: (error) => {
      this.snackBarService.error(
        error?.error?.applicationMessage || 'Failed to fetch patient details'
      );
    }
  });
}
  onClose(): void {
    this.pservice.notifyAnalysisRequested(true); 
    this.myReportsService.notifyAnalysisRequested(true);
    this.dialogRef.close();
  }
}
